import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import BgPattern from '../BgPattern'

const propTypes = {
  document: PropTypes.object,
  productArray: PropTypes.array,
  linkResolver: PropTypes.func,
  locale: PropTypes.string
}

class ProductCompare extends Component {
  render() {
    let { 
      document,
      productArray,
      linkResolver,
      locale,
    } = this.props

    return (
      <section id="compare" className="section-compare">
        <BgPattern/>
         <div className="container">
          {PrismicReact.RichText.render(document.table_title)}
          <Table>
            <thead>
              <tr>
                {
                  document.table_column_titles.map((th, index) => {
                    return (
                      <th key={index}>{th.title}</th>
                    )
                  })
                }
              </tr>
            </thead>
            <tbody>
              {
                productArray.map((p, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row">
                        <h4>{PrismicReact.RichText.asText(p.data.product_title)}</h4>
                        {
                          locale === 'en-ca' ?
                          <Link to={`our-strains/${p.uid}`} className="button">View Details</Link>  
                          :
                          <Link to={`nos-souches/${p.uid}`} className="button">Voir les détails</Link>  
                        }
                      </th>
                      <td>
                        <ul className="flexbox">
                          {
                            p.data.product_type.map((aroma, index) => {
                              return (
                                <li key={index}><img src={aroma.icon_small.url} alt={aroma.icon_name} className="icon"/></li>
                              )
                            })
                          }
                        </ul>
                      </td>
                      <td>{p.data.strain_type}</td>
                      <td>{p.data.strain_thc_levels}</td>
                      <td>{p.data.strain_cbd_levels}</td>
                      { 
                        p.data.pairs_with_section.length > 0 &&
                          <td>
                            <ul>
                              {
                                p.data.pairs_with_section.map((pair, index) => {
                                  return (
                                    <li key={index}>{PrismicReact.RichText.asText(pair.icon_name)}</li>
                                  )
                                })
                              }
                            </ul>
                        </td>
                      }
                      <td>
                        <ul className="flexbox">
                          {
                            p.data.dominant_aroma_section.map((aroma, index) => {
                              return (
                                <li key={index}><img src={aroma.icon_small.url} alt={aroma.icon_name} className="icon"/></li>
                              )
                            })
                          }
                        </ul>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
         </div>
      </section>
    )
  }
}

ProductCompare.propTypes = propTypes

export default ProductCompare


// WEBPACK FOOTER //
// ./src/components/OurStrains/CompareSection.js